import { API } from "aws-amplify";

const API_NAME = "WebhooksAPI"; // Add this API to your Amplify config (aws-exports)
const BASE_PATH = "/webhook";
const CHAT_PATH = "/chat/send";

export default class AiAssistantService {
    async sendWebhook(payload) {
        // Amplify will attach the configured auth (Cognito token / IAM) for this API if configured
        return API.post(API_NAME, BASE_PATH, { body: payload });
    }
    async sendChatMessage(payload) {
        // Amplify will attach the configured auth (Cognito token / IAM) for this API if configured
        return API.post(API_NAME, CHAT_PATH, { body: payload });
    }
}
